import { IApplicationState } from '../../types/redux';

export const getIsNewbuildingPromoSnippetEnabled = (state: IApplicationState) => state.config.isPromoSnippetEnabled;
